export default __webpack_public_path__ + "cbdc7e9f241e185945fa7a6d6bf4ca59.png";